import api, { USE_MOCK, qs } from './apiClient';

/**
 * Pinned documents — the shared kind, not the personal star.
 *
 * What comes back is already filtered by the server for whoever is asking, so the interface
 * can render a band without checking anything itself. That is deliberate: a permission rule
 * enforced in two places is a permission rule that will eventually disagree with itself.
 */
export const pinService = {
  /** The dashboard band: organisation pins plus my departments'. */
  band() {
    if (USE_MOCK) return Promise.resolve([]);
    return api.get('/pins');
  },

  /** One department's band, for its own page. */
  forDepartment(departmentId) {
    if (USE_MOCK) return Promise.resolve([]);
    return api.get(`/pins${qs({ departmentId })}`);
  },

  /** Everything I can see pinned, for the "view all" screen. */
  all() {
    if (USE_MOCK) return Promise.resolve([]);
    return api.get(`/pins${qs({ all: true })}`);
  },

  /** Where I am allowed to pin, so the dialog offers only those. */
  scopes() {
    if (USE_MOCK) return Promise.resolve([]);
    return api.get('/pins/scopes');
  },

  /** Where this document is pinned already. */
  forDocument(documentId) {
    if (USE_MOCK) return Promise.resolve([]);
    return api.get(`/documents/${documentId}/pins`);
  },

  /** Pin it, or revise the pin that is already there — the server upserts. */
  pin(documentId, { scope, departmentId, note, expiresAt }) {
    if (USE_MOCK) return Promise.resolve({});
    return api.post(`/documents/${documentId}/pins`, {
      scope,
      departmentId: departmentId || null,
      note: note || '',
      expiresAt: expiresAt || null,
    });
  },

  unpin(pinId) {
    if (USE_MOCK) return Promise.resolve();
    return api.delete(`/pins/${pinId}`);
  },
};

export default pinService;
